import Spinner from "@/components/Spinner";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { useNavigate } from "react-router";
import { endpoints } from "../../../hooks/endpoints";
import { getToken } from "../../../hooks/utils";
import { subscriptionTierMapper } from "../../../scripts/subscriptionTierMapper";
import { useAppDispatch } from "../../../store/hooks";
import { resetModals } from "../../../store/slices/modalsSlice";
import ModalWrapper from "../../Modals/ModalWrapper";

const SubscriptionModal = ({ tier }) => {
  const dispatch = useAppDispatch();
  const [error, setError] = useState<{
    status: number;
    message: string;
    data: string;
  }>(null);
  const [isPending, setIsPending] = useState(false);
  const navigate = useNavigate();

  const handleSubscription = () => {
    setIsPending(true);
    fetch(endpoints.createSubscription, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken(),
      },
      body: JSON.stringify({ tier }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 200) {
          navigate("/dashboard");
          dispatch(resetModals());
        } else {
          setError(data);
        }
      })
      .catch((err) =>
        setError({ status: 500, message: err.message, data: err.message })
      )
      .finally(() => setIsPending(false));
  };

  if (tier === "free")
    return (
      <ModalWrapper>
        <div className="text-center p-4 mx-auto bg-white rounded-lg w-full max-w-md">
          <h5 className="mb-4 text-lg font-semibold">
            بعد إنتهاء صلاحية الباقة الحالية يتم تحويلك تلقائياً للباقة
            المجانية
          </h5>
          <div className="flex justify-around gap-2">
            <button
              className="text-primary rounded-lg px-4 py-2 border border-primary"
              onClick={() => dispatch(resetModals())}
            >
              حسناً
            </button>
          </div>
        </div>
      </ModalWrapper>
    );

  return (
    <ModalWrapper>
      <div className="text-center p-8 mx-auto bg-white rounded-lg max-w-md">
        <h5 className="mb-4 text-lg font-semibold">
          هل تريد الاشتراك في الباقة {subscriptionTierMapper(tier).title} ؟
        </h5>
        <div className="flex justify-center gap-6">
          <Button
            className={`px-4 py-2 rounded-lg bg-green-600 text-white hover:bg-green-700 ${
              isPending ? "opacity-50 cursor-not-allowed" : ""
            }`}
            onClick={handleSubscription}
            disabled={isPending}
          >
            {isPending ? <Spinner variant="button" /> : "نعم"}
          </Button>
          <Button
            className="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700"
            onClick={() => dispatch(resetModals())}
          >
            إلغاء
          </Button>
        </div>
        {!!error && (
          <>
            <p className="text-red-600 mt-2 mb-0">{error.data}</p>
            {error?.message === "insufficient_credit" && (
              <button
                className="mt-2 px-4 py-2 rounded-lg bg-primary text-white hover:bg-primary/90"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/dashboard/wallet");
                  window.scrollTo(0, 0);
                  dispatch(resetModals());
                }}
              >
                إشحن رصيد
              </button>
            )}
          </>
        )}
      </div>
    </ModalWrapper>
  );
};

export default SubscriptionModal;
